import {
  BasicButton,
  Container,
  Grid,
  Layout,
  PrimaryButton,
  SecondaryTopNav,
  Stack,
  Text,
} from "@certn/cascadia-react";
import { t } from "i18next";
import { PropsWithChildren, useState } from "react";
import { useNavigate } from "react-router-dom";

import { CancelModal } from "../CancelModal";

interface Props extends PropsWithChildren {
  disableCompletion?: boolean;
  submitting?: boolean;
  onComplete?: () => void;
}

export function CredentialTemplatePageLayout(props: Props) {
  const { disableCompletion, submitting, onComplete, children } = props;

  const navigate = useNavigate();
  const [showCancelModal, setShowCancelModal] = useState(false);

  const handleCancel = () => {
    setShowCancelModal(false);
    navigate("/settings/credential-verification-templates");
  };

  return (
    <Layout
      layout="narrow"
      header={
        <SecondaryTopNav
          testID="close-button"
          leftIcon="close"
          onleftIconOnPress={() => setShowCancelModal(true)}
        >
          <BasicButton
            onPress={() => {
              setShowCancelModal(true);
            }}
            isLoading={submitting}
            testID="cred-verification-template-cancel-button"
          >
            {t("Cancel")}
          </BasicButton>
          <PrimaryButton
            onPress={() => {
              onComplete?.();
            }}
            isDisabled={disableCompletion}
            isLoading={submitting}
          >
            {t("Save template")}
          </PrimaryButton>
        </SecondaryTopNav>
      }
    >
      <Container>
        <div>
          <Stack gap="space-3">
            <Text as="h1" style="global/title-medium">
              {t("Create credential verification template")}
            </Text>
          </Stack>
        </div>

        <Grid form>{children}</Grid>
        {showCancelModal && (
          <CancelModal
            onCancel={handleCancel}
            onClose={() => setShowCancelModal(false)}
          />
        )}
      </Container>
    </Layout>
  );
}
